import axios from 'axios';

const API_BASE = '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export const surveyAPI = {
  getAll: () => api.get('/surveys'),
  getOne: (id) => api.get(`/surveys/${id}`),
  create: (data) => api.post('/surveys', data),
  update: (id, data) => api.patch(`/surveys/${id}`, data),
  delete: (id) => api.delete(`/surveys/${id}`),
  getAnalytics: (id) => api.get(`/surveys/${id}/analytics`),
  getMySurveys: () => api.get('/my_surveys'),
  getMyResponses: (id) => api.get(`/surveys/${id}/my_responses`),
};

export const responseAPI = {
  submit: (surveyId, responses) => api.post(`/surveys/${surveyId}/responses`, responses),
};

export const analyticsAPI = {
  getDashboard: () => api.get('/analytics/dashboard'),
};

export const authAPI = {
  getCurrentUser: () => api.get('/current_user'),
  logout: () => axios.delete('/users/sign_out', { withCredentials: true }),
};

export default api;
